<template>
  <div class="material">

    <!-- select client -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="4" v-if="!internalUse">
        <el-select v-model="taskClientListId" placeholder="Select client" size="mini">
          <el-option v-for="item in taskClientList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-switch
          v-model="internalUse"
          active-text="Internal use">
        </el-switch>
      </el-col>
    </el-row>

    <el-form v-if="taskClientListId || internalUse" :model="ruleForm" ref="ruleForm" :rules="rules" status-icon label-width="150px" label-position="left">

      <!-- header -->
      <el-row :gutter="40" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-form-item label="Issue Date" prop="issueDate" size="mini">
            <el-date-picker type="date"
              format="d MMM yy"
              placeholder="Issue Date"
              v-model="ruleForm.issueDate"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="Currency" prop="currency" size="mini">
            <el-input v-model="ruleForm.currency" placeholder="Currency" disabled></el-input>
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item label="Amounts Are" prop="amountsAre" size="mini">
            <el-select v-model="ruleForm.amountsAre" placeholder="Amounts Are" style="width: 100%;" clearable>
              <el-option v-for="item in ruleForm.amountsAreList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Discount %" prop="discount" size="mini">
            <el-input type="number" min="0" max="100" v-model="ruleForm.discount" @change="changeTable()" placeholder="Discount" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>

          <el-form-item label="Subject" prop="subject">
            <el-input type="textarea" v-model="ruleForm.subject"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- title -->
      <el-row :gutter="10" class="selectRowTitle" style="margin-bottom: 20px;">
        <el-col v-for="row in rowTitles" :key="row.title" :span="row.span">
          <div class="selectRowTitle__item">{{row.title}}</div>
        </el-col>
      </el-row>

      <!-- add row -->
      <el-form :model="selectRow" ref="selectRow" :rules="rulesRow" style="margin-bottom: 20px;">

        <el-row :gutter="10">
          <el-col :span="3">
            <el-form-item prop="itemId" size="mini">
              <el-select v-model="selectRow.itemId" placeholder="Select item" size="mini" style="width: 100%;">
                <el-option v-for="item in itemList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="selectItem(item)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="shortNote" size="mini">
              <el-input v-model="selectRow.shortNote" placeholder="Short note" size="mini" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item prop="quantity" size="mini">
              <el-input type="number" v-model="selectRow.quantity" @keyup.native="changeRow()" placeholder="Quantity" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item prop="pricePerUnit" size="mini">
              <el-input type="number" v-model="selectRow.pricePerUnit" @keyup.native="changeRow()" placeholder="Price Per Unit" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item prop="costPrice" size="mini">
              <el-input type="number" v-model="selectRow.costPrice" @keyup.native="changeRow()" placeholder="Cost Price" size="mini" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item prop="markUp" size="mini">
              <el-input type="number" v-model="selectRow.markUp" @keyup.native="changeRow()" placeholder="Mark Up" size="mini" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item size="mini">
              <el-input type="number" v-model="selectRow.discount" @keyup.native="changeRow()" placeholder="Discount" size="mini" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="taxId" size="mini">
              <el-select v-model="selectRow.taxId" placeholder="Taxes" size="mini" style="width: 100%;">
                <el-option v-for="item in taxesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item size="mini">
              <el-input disabled type="number" v-model="selectRow.amount" placeholder="Amount" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button @click="createRow('selectRow')" type="primary" plain size="mini" style="width: 100%;">Add</el-button>
          </el-col>
        </el-row>

      </el-form>

      <!-- TODO table -->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="tableList.filter(data => !search || data.item.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%"
            border>
            <el-table-column
              label="Item"
              sortable>
              <template slot-scope="scope">
                <el-select v-model="scope.row.itemId" disabled placeholder="Item" size="mini" style="width: 100%;">
                  <el-option v-for="item in itemList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="Short note">
              <template slot-scope="scope">
                <el-input v-model="scope.row.shortNote" placeholder="Short note" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Qty">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" @keyup.native="changeTable(scope.row)" placeholder="Quantity" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Price Per Unit">
              <template slot-scope="scope">
                <el-input v-model="scope.row.pricePerUnit" @keyup.native="changeTable(scope.row)" placeholder="Price Per Unit" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
              </template>
            </el-table-column>

            <!-- TODO: -->
            <el-table-column
              label="Cost Price">
              <template slot-scope="scope">
                <el-input v-model="scope.row.costPrice" @keyup.native="changeTable(scope.row)" placeholder="Cost Price" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Mark Up %">
              <template slot-scope="scope">
                <el-input v-model="scope.row.markUp" @keyup.native="changeTable(scope.row)" placeholder="Mark Up" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
              </template>
            </el-table-column>

            <el-table-column
              label="Discount %">
              <template slot-scope="scope">
                <el-input v-model="scope.row.discount" @keyup.native="changeTable(scope.row)" placeholder="Discount" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Taxes">
              <template slot-scope="scope">
                <el-select v-model="scope.row.taxId" placeholder="Taxes" size="mini" style="width: 100%;">
                  <el-option v-for="item in taxesList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="changeTable()">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="Amount"
              prop="amount">
            </el-table-column>
            <el-table-column
              align="right">
              <template slot="header" slot-scope="{}">
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="Type to search"/>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <!-- TODO footer -->
      <el-row type="flex" justify="end">
        <el-col :span="10">
          <div class="price">
            <div v-if="ruleForm.amountsAre == 1" class="price__item">
              <div>Includes Tax of</div>
              <div>{{taxInclusive || '0.00'}}</div>
            </div>
            <div class="price__item price__item_border">
              <div>Total Discount</div>
              <div>{{totalDiscount || '0.00'}}</div>
            </div>
            <div class="price__item">
              <div>Subtotal</div>
              <div>{{ruleForm.subtotal || '0.00'}}</div>
            </div>
            <div v-if="ruleForm.amountsAre == 0" class="price__item">
              <div>+ Tax of</div>
              <div>{{taxExclusive || '0.00'}}</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-row type="flex" justify="space-between" style="margin-bottom: 0px;">
            <el-col :span="4" class="createInvoice">
              <el-button type="primary" plain @click="submitForm('ruleForm')">Save Material</el-button>
            </el-col>

            <el-col :span="10">
              <div class="amount">
                <div>Total Amount: </div>
                <div>{{totalAmount}} {{ruleForm.currency}}</div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

    </el-form>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment')

  export default {
    computed: {
      item() {
        return this.$store.state.projectMaterialItemProj
      },
      directories() {
        return this.$store.state.projectMaterialDirectoriesProj
      },
      totalDiscount() {
        return this.ruleForm.totalDiscount
      },
      taxExclusive() {
        return this.ruleForm.taxesExc
      },
      taxInclusive() {
        return this.ruleForm.taxesInc
      },
      totalAmount() {
        return this.ruleForm.amountsAre == 0 ? (+this.ruleForm.subtotal + +this.taxExclusive).toFixed(2) : (+this.ruleForm.subtotal).toFixed(2)
      },
    },
    watch: {
      item(val) {
        if (val.general) {
          this.taskClientListId = val.general.clientId
          this.internalUse = val.general.isInternal

          // ruleForm
          this.ruleForm.issueDate = val.general.issueDate
          this.ruleForm.amountsAre = val.general.amountsType
          this.ruleForm.discount = val.general.discount
          this.ruleForm.subject = val.general.subject

          this.tableList = val.list
        } else {
          this.taskClientListId = null
          this.internalUse = false

          // ruleForm
          this.ruleForm.issueDate = ''
          this.ruleForm.amountsAre = 0
          this.ruleForm.discount = null
          this.ruleForm.subject = ''

          this.tableList = []
        }
      },
      directories(val) {
        this.taskClientList = val.clientList
        this.itemList = val.companyInventoryItemList
        this.itemList.splice(0, 2)
        this.taxesList = val.taxList
        this.ruleForm.currency = val.currency.code
        this.ruleForm.currencyId = val.currency.id
      },
      tableList(val) {
        this.changeTable()
      },
    },
    data() {
      return {
        moment:moment,

        // main table
        tableList: [],
        search: '',

        internalUse: false,

        taskClientList: [],
        taskClientListId: null,
        itemList: [],
        taxesList: [],

        rowTitles: [
          {title: 'Item', span: 3},
          {title: 'Short note', span: 4},
          {title: 'Qty', span: 2},
          {title: 'Price per unit', span: 2},
          {title: 'Cost price', span: 2},
          {title: 'Mark Up %', span: 2},
          {title: 'Discount %', span: 2},
          {title: 'Taxes', span: 3},
          {title: 'Amount', span: 2},
          {title: '', span: 2}
        ],

        // select row
        selectRow: {
          itemId: null,
          shortNote: null,
          taxId: null,
          quantity: 1,

          costPrice: null,
          pricePerUnit: null,
          markUp: null,

          discount: null,
          discountSum: null,
          amount: null,
        },

        ruleForm:{
          issueDate: '',
          currency: '',
          currencyId: null,

          amountsAre: 0,
          amountsAreList: [{
              label: 'Tax Exclusive',
              value: 0,
            },{
              label: 'Tax Inclusive',
              value: 1,
          }],
          discount: null,
          subject: '',

          totalDiscount: null,
          subtotal: null,
          taxesExc: null,
          taxesInc: null,
        },
        rules: {
          issueDate: [
            { required: true, message: 'Please select Issue Date', trigger: 'change' }
          ],
          currency: [
            { required: true, message: 'Please select Currency', trigger: 'change' }
          ],
          amountsAre: [
            { required: true, message: 'Please select Invoice Template', trigger: 'change' }
          ],
          subject: [
            { required: true, message: 'Please select Subject', trigger: 'blur' }
          ],
        },
        rulesRow: {
          itemId: [
            { required: true, message: 'Please input Type', trigger: 'blur' },
          ],
          shortNote: [
            { required: true, message: 'Please select Short Note', trigger: 'change' }
          ],
          quantity: [
            { required: true, message: 'Please select Quantity', trigger: 'change' }
          ],
          taxId: [
            { required: true, message: 'Please select Taxes', trigger: 'change' }
          ],
          pricePerUnit: [
            { required: true, message: 'Please select Price Per Unit', trigger: 'change' }
          ],
          costPrice: [
            { required: true, message: 'Please select Cost Price', trigger: 'change' }
          ]
        },
      }
    },
    methods: {
      // * add row
      createRow(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let obj = {
              itemId: this.selectRow.itemId,
              shortNote: this.selectRow.shortNote,
              taxId: this.selectRow.taxId,
              quantity: this.selectRow.quantity,
              pricePerUnit: this.selectRow.pricePerUnit,
              costPrice: this.selectRow.costPrice,
              markUp: this.selectRow.markUp,
              amount: this.selectRow.amount,
              discount: this.selectRow.discount,
              discountSum: this.selectRow.discountSum,
            }

            this.tableList.push(obj)

            this.$refs['selectRow'].resetFields();
            this.selectRow.itemId = null
            this.selectRow.discount = null
            this.selectRow.discountSum = null
            this.selectRow.amount = null
            this.selectRow.quantity = 1

            this.selectRow.costPrice = null
            this.selectRow.pricePerUnit = null
            this.selectRow.markUp = null
          } else {
            return false;
          }
        });
      },
      // TODO:
      selectItem(item) {
        // console.log('---', item)
        if (item.sellPrice) this.selectRow.pricePerUnit = item.sellPrice
        if (item.buyPrice) this.selectRow.costPrice = item.buyPrice
        if (item.projectTaxId) this.selectRow.taxId = item.projectTaxId
        this.selectRow.markUp = null
        this.selectRow.discount = null
        this.changeRow()
      },
      // * change row
      changeRow() {
        if (this.selectRow.markUp) {
          this.selectRow.pricePerUnit = +this.selectRow.costPrice + (+this.selectRow.costPrice / 100 * +this.selectRow.markUp)
        } else {
          this.selectRow.pricePerUnit = this.selectRow.costPrice
        }

        this.selectRow.amount = (+this.selectRow.pricePerUnit - ((this.selectRow.pricePerUnit * this.selectRow.discount) / 100)).toFixed(2)
        this.selectRow.amount = (+this.selectRow.amount * +this.selectRow.quantity).toFixed(2)
        this.selectRow.discountSum = ((this.selectRow.pricePerUnit * this.selectRow.discount) / 100).toFixed(2)
      },
      // * change table
      changeTable(row) {
        let amountAll = 0
        let discountAll = 0
        let taxesExcAll = 0
        let taxesIncAll = 0
        for (let i = 0; i < this.tableList.length; i++) {

          if (this.tableList[i].markUp) {
            this.tableList[i].pricePerUnit = +this.tableList[i].costPrice + (+this.tableList[i].costPrice / 100 * +this.tableList[i].markUp)
          } else {
            this.tableList[i].pricePerUnit = this.tableList[i].costPrice
          }

          this.tableList[i].amount = (+this.tableList[i].pricePerUnit - ((this.tableList[i].pricePerUnit * this.tableList[i].discount) / 100)).toFixed(2)
          this.tableList[i].amount = (+this.tableList[i].amount * +this.tableList[i].quantity).toFixed(2)
          this.tableList[i].discountSum = ((this.tableList[i].pricePerUnit * this.tableList[i].discount) / 100).toFixed(2)
          this.tableList[i].taxesSumExc = 0
          this.tableList[i].taxesSumInc = 0

          let taxesValue = null
          for (let j = 0; j < this.taxesList.length; j++) {
            if (this.taxesList[j].id == this.tableList[i].taxId) {
              taxesValue = this.taxesList[j].value
            }
          }

          this.tableList[i].taxesSumExc = (+this.tableList[i].amount * taxesValue) / 100
          taxesExcAll += this.tableList[i].taxesSumExc

          this.tableList[i].taxesSumInc = +this.tableList[i].amount - ((+this.tableList[i].amount * 100) / (100 + taxesValue))
          taxesIncAll += this.tableList[i].taxesSumInc

          amountAll += +this.tableList[i].amount
          discountAll += +this.tableList[i].discountSum
        }

        this.ruleForm.subtotal = amountAll.toFixed(2)
        this.ruleForm.totalDiscount = discountAll.toFixed(2)
        this.ruleForm.taxesExc = taxesExcAll.toFixed(2)
        this.ruleForm.taxesInc = taxesIncAll.toFixed(2)

        if (!!this.ruleForm.discount && +this.ruleForm.subtotal > 0) {
          this.ruleForm.totalDiscount = (+this.ruleForm.totalDiscount + ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)

          this.ruleForm.subtotal = (+this.ruleForm.subtotal - ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)
        }
      },
      // * delete row
      handleDelete(index, row) {
        this.$confirm('This will permanently delete item? Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete'
          });

          this.tableList.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      // * save
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();

            if (this.ruleForm.discount == '') this.ruleForm.discount == null

            let list = [];
            let tableList = this.tableList
            for (let i = 0; i < tableList.length; i++) {
              let obj = {
                id: undefined,
                shortNote: tableList[i].shortNote,
                quantity: null,

                // FIXME: unitPrice -> pricePerUnit
                pricePerUnit: +tableList[i].pricePerUnit,
                // add
                costPrice: +tableList[i].costPrice,
                markUp: +tableList[i].markUp,

                discount: +tableList[i].discount,
                amount: +tableList[i].amount,
                itemId: tableList[i].itemId,
                taxId: tableList[i].taxId
              }

              if (this.tableList[i].quantity === null) {
                obj.quantity = 1
              } else {
                obj.quantity = +this.tableList[i].quantity
              }

              list.push(obj)
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/project-materials/save?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`, {
              general: {
                issueDate: this.ruleForm.issueDate,
                amountsType: this.ruleForm.amountsAre,
                discount: this.ruleForm.discount,
                subject: this.ruleForm.subject,
                isInternal: this.internalUse,
                clientId: this.taskClientListId,
                currencyId: this.ruleForm.currencyId
              },

              list: list,
            })
            .then(response => {
              this.notification("Success", "Save material", "success")
            })
            .catch(error => {})
            .finally(() => {
              loader.hide()
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .selectRowTitle {
    font-size: 14px;
    font-weight: bold;
    color: #909399;
    &__item {
      // padding-left: 10px;
    }
  }

  .price {
    padding: 20px;
    font-weight: bold;
    &__item{
      display: flex;
      justify-content: space-between;
      padding: 4px;
      &_border{
        border-bottom: 1px solid #000;
      }
    }
  }

  .createInvoice {
    padding: 20px;
    font-size: 30px;
  }

  .amount {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    font-size: 30px;
    font-weight: bold;
  }
</style>
